/**
 * Complete-setup quote form — inline sibling of assets/product-quote-modal.js.
 *
 * Same fields and the same POST /leads JSON payload as the product quote modal,
 * but the form lives in the page (no <dialog>) and carries one extra choice:
 * which package the customer wants quoted — the core set or core + recommended.
 * The package tiles ARE the radio inputs, so the choice and the price the
 * customer is looking at can never drift apart.
 *
 * Lives in its own asset rather than a section's {% javascript %} block: that
 * bundle is shared across sections, and one fault anywhere in it would stop the
 * submit interception from attaching, letting the form navigate away.
 *
 * source is `set_quote` — its own value in the leads vocabulary (API LeadSource +
 * the leads_source_check constraint), so setup inquiries can be told apart from
 * single-product quotes in the Обращения inbox. The setup name, URL, chosen
 * package and its total ride in `details`.
 */
(function () {
  function initSetupQuote() {
    var form = document.querySelector('[data-setup-quote]');
    if (!form) return;

    var root = form.closest('[data-setup-quote-root]') || form.parentNode;
    var successEl = root.querySelector('[data-setup-quote-success]');
    var errorEl = root.querySelector('[data-setup-quote-error]');
    var retryBtn = root.querySelector('[data-setup-quote-retry]');
    var leadsUrl = form.dataset.leadsUrl || '/leads';
    var turnstileRequired = form.dataset.turnstileRequired === 'true';

    function submitBtn() {
      return form.querySelector('[data-setup-quote-submit]');
    }

    // Turnstile: token read at submit time, button never disabled. The callbacks only
    // clear the notice once the widget catches up — nothing is gated on them, because a
    // lost callback used to leave this button dead forever. See the contract in
    // assets/lead-submit.js.
    function turnstileToken() {
      return window.bqLeadToken(form);
    }

    function clearHint() {
      if (turnstileToken()) window.bqLeadHint(form, false);
    }

    window.onSetupTurnstileVerify = clearHint;
    window.onSetupTurnstileExpired = clearHint;
    window.onSetupTurnstileError = clearHint;

    function showForm() {
      form.hidden = false;
      if (successEl) successEl.hidden = true;
      if (errorEl) errorEl.hidden = true;
      var btn = submitBtn();
      if (btn && btn.dataset.labelSubmit) btn.textContent = btn.dataset.labelSubmit;
      window.bqLeadHint(form, false);
    }

    function showSuccess() {
      form.hidden = true;
      if (errorEl) errorEl.hidden = true;
      if (successEl) {
        successEl.hidden = false;
        successEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }

    function showError() {
      form.hidden = true;
      if (successEl) successEl.hidden = true;
      if (errorEl) errorEl.hidden = false;
    }

    if (retryBtn) retryBtn.addEventListener('click', showForm);

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // No token yet: say so instead of failing silently. The widget usually just
      // hasn't finished — clicking again once it shows its checkmark goes through.
      if (turnstileRequired && !turnstileToken()) {
        window.bqLeadHint(form, true);
        return;
      }
      window.bqLeadHint(form, false);

      var btn = submitBtn();
      if (btn && btn.dataset.labelSubmitting) btn.textContent = btn.dataset.labelSubmitting;

      // The package choice is the one thing plain [data-lead-detail] inputs can't
      // express — it lives on the checked radio, whose tile shows the price.
      var extra = {};
      var pkg = form.elements['package'];
      var checked = form.querySelector('input[name="package"]:checked');
      if (pkg && pkg.value) extra.package = String(pkg.value);
      if (checked) {
        if (checked.dataset.packageLabel) extra.package_label = checked.dataset.packageLabel;
        if (checked.dataset.packageTotal) extra.package_total = checked.dataset.packageTotal;
      }

      var payload = window.bqBuildLeadPayload(form, 'set_quote', extra);
      window.bqSubmitLead(leadsUrl, payload).then(function (ok) {
        if (ok) showSuccess(); else showError();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSetupQuote);
  } else {
    initSetupQuote();
  }
})();
